export const PO_BOX_PREFIX = "UBXCR";
export const DYNAMIC_DATA_SPLITTER = ":";
export const DYNAMIC_DATA_VALUE_INDEX = 0;
export const DYNAMIC_DATA_FORMAT_INDEX = 1;
export const WEIGTH_ROUND_FACTOR = 0.5;
export const EMPTY_STRING = " ";
export const SHIPPING_COST_PRODUCT_ID = 35;
export const KG_CONVERT_FACTOR = 2.20462;
export const LB_CONVERT = 0.453592;

export const REFERAL_AMOUNT_BENEFITS = 5;

export const JSON_TABLE_INPUT_TYPE = "jsonTable";
export const DYNAMIC_TYPE_INPUT_TYPE = "dynamicTypeInput";
export const SELECT_INPUT_TYPE = "select";
export const RADIO_INPUT_TYPE = "radioInput";
export const EDITOR_INPUT = "editor";
export const FILE_UPLOAD_INPUT = "FileUpload";
export const HIDDEN_INPUT_TYPE = "hidden";
export const ADDRESS_SELECT_INPUT_TYPE = "addressSelect";
export const DELIVERY_DETAILS_ELEMENT_TYPE = "deliveryDetails";
export const COURIER_ADDRESS_CODE = "courier";
export const COURIER_ADDRESS_LABEL = "En Sucursal";

export const REFERAL_USER_COOKIE_NAME = "referalUser";

export const USER_GROUPS = {
    'ADMIN': "admins",
    'CLIENTS': "Clients"
}

export const VALIDATION_ERROR_MESSAGE = {
    'REQUIRED_FIELD_ERROR': "Este campo es requerido",
    'EMAIL_FIELD_ERROR': "Por favor ingrese un correo electronico valido",
    'REQUIRED_JSON_TABLE_ERROR': "Es necesario agregar al menos un registro en esta tabla",
    'POSITIVE_NUMBER_ERROR': "Este campo es deber ser mayor a 0",
}

export const DATATYPES = {
    'RAW': "raw",
    'INT': "int",
    'SELECT': "select",
    'DECIMAL': "decimal",
    'STRING': "String",
    'BOOLEAN': "bool",
    'OBJECT': "object",
    'ADDRESS': "address",
    'FILE_INPUT': "fileInput"
}

export const DEFAULT_INPUT_SIZING = {
    xs: 12,
    sm: true
};

export const COURIER_TRANSPORTAION_KEY = "COURIER"

export const TRANSPORTAION_KEYS = {
    [COURIER_TRANSPORTAION_KEY]: "Manifiesto Paqueteria",
    "AIR": "Importacion Aerea",
    "SEA": "Importacion Maritima",
    "GROUND": "Importacion Terrestre",
    "DELIVERY": "Despacho Importacion",
    "EXP_AIR": "Exportacion Aerea",
    "EXP_SEA": "Exportacion Maritima",
    "EXP_GROUND": "Exportacion Terrestre",
    "EXP_DELIVERY": "Despacho Exportacion",
}

export const IVA_PERCENTAGES_CODES = {
    "01": "0% (Exento)",
    "08": "General 13%",
    "02": "Reducida 1%",
    "03": "Reducida 2%",
    "04": "Reducida 4%",
    "05": "Transitorio 1%",
    "06": "Transitorio 4%",
    "07": "Transitorio 8%",
}

export const IVA_PERCENTAGES = {
    "01": Number(0),
    "08": Number(0.13),
    "02": Number(0.01),
    "03": Number(0.02),
    "04": Number(0.04),
    "05": Number(0.01),
    "06": Number(0.04),
    "07": Number(0.08),
}

export const COURIERS = {
    "AMAZON": "Amazon",
    "CHINA": "China Post",
    "DHL": "DHL",
    "FEDEX": "fedex",
    "UPS": "UPS",
    "USPS": "USPS",
    "EMS": "EMS",
    "OTHER": "OTHER",
}

export const DUA_STATUS = {
    "green": "Verde",
    "yellow": "Amarillo",
    "red": "Rojo",
};
export const DELIVERY_ROUTE_STATUS_CODES = {
    "SCHEDULED": "scheduled",
    "ON_ROUTE": "En on_route",
    "DELIVERIED": "deliveried",
};

export const DELIVERY_ROUTE_STATUS = {
    [DELIVERY_ROUTE_STATUS_CODES.SCHEDULED]: "Programado",
    [DELIVERY_ROUTE_STATUS_CODES.ON_ROUTE]: "En Ruta",
    [DELIVERY_ROUTE_STATUS_CODES.DELIVERIED]: "Entregado",
};

export const CR_PROVINCES = {
    "1": "San José",
    "2": "Alajuela",
    "3": "Cartago",
    "4": "Heredia",
    "5": "Guanacaste",
    "6": "Puntarenas",
    "7": "Limón",
}

export const ID_TYPES = {
    "01": "Cedula Física",
    "02": "Cedula Jurídica",
    "03": "(Dimex) Identificacion Extranjeros",
    "04": "(NITE) Identificacion Tributaria Espacial"
}

export const EMAIL_COST_ENTRIES_KEY = {
    "SHIPPING_COST": "shippingCost",
    "TAX_COST": "taxCost",
    "LOCAL_SHIPPING_COST": "localShippingCost",
    "SUBTOTAL": "subtotal",
    "IVA": "iva",
    "TOTAL": "total"
}
export const MOVEMENT_STATUS_CODES = {
    "ON_WAIT": "onWait",
    "ON_ORIGIN": "onOrigin",
    "ON_SCHEDULE": "onSchedule",
    "ON_TRANSIT": "onTransit",
    "ON_DESTINY": "onDestiny",
    "ON_CUSTOMS": "onCustoms",
    "ON_RED": "onRed",
    "ON_TRANSIT_COURIER": "onTransitCourier",
    "ON_COURIER": "onCourier",
    "DELIVERIED": "deliveried",
    "RECEIVED": "received",
    "ON_ROUTE": "onRoute",
}

export const MOVEMENT_STATUS = {
    [MOVEMENT_STATUS_CODES.ON_WAIT]: "En Camino a Warehouse",
    [MOVEMENT_STATUS_CODES.ON_ORIGIN]: "Recibido en Bodega Origen",
    [MOVEMENT_STATUS_CODES.ON_SCHEDULE]: "Programado en Siguiente Vuelo",
    [MOVEMENT_STATUS_CODES.ON_TRANSIT]: "En Transito",
    [MOVEMENT_STATUS_CODES.ON_DESTINY]: "Aviso de Arribo",
    [MOVEMENT_STATUS_CODES.ON_CUSTOMS]: "En Proceso Aduanal",
    [MOVEMENT_STATUS_CODES.ON_RED]: "En Aforo Rojo Aduanal",
    [MOVEMENT_STATUS_CODES.ON_TRANSIT_COURIER]: "En transito a Sucursal",
    [MOVEMENT_STATUS_CODES.ON_COURIER]: "Listo Para Entrega",
    [MOVEMENT_STATUS_CODES.DELIVERIED]: "Entregado",
    [MOVEMENT_STATUS_CODES.RECEIVED]: "Recibido en Miami",
}

export const IN_MIAMI_STATUS = [MOVEMENT_STATUS_CODES.ON_ORIGIN, MOVEMENT_STATUS_CODES.ON_WAIT, MOVEMENT_STATUS_CODES.RECEIVED]
export const IN_COSTA_RICA_STATUS = [MOVEMENT_STATUS_CODES.ON_COURIER, MOVEMENT_STATUS_CODES.ON_CUSTOMS, MOVEMENT_STATUS_CODES.ON_DESTINY, MOVEMENT_STATUS_CODES.ON_RED, MOVEMENT_STATUS_CODES.ON_ROUTE]
export const IN_TRANSIT_STATUS = [MOVEMENT_STATUS_CODES.ON_TRANSIT, MOVEMENT_STATUS_CODES.ON_SCHEDULE]

export const PACKAGE_NOTIFICATIONS = {
    PACKAGE_RECEIVED: "package_received",
    PACKAGE_ON_STATUS_CHANGE: "package_on_status_change",
    PACKAGE_READY_TO_PICK_UP: "package_ready_to_pick_up",
    PACKAGE_COST: "package_cost",
    PACKAGE_ON_ROUTE: "package_on_route",
}

export const PACKAGE_NOTIFICATIONS_SUBJECT = {
    [PACKAGE_NOTIFICATIONS.PACKAGE_RECEIVED]: "Notificación de paquete recibido",
    [PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE]: "Notificación sobre tu paquete",
    [PACKAGE_NOTIFICATIONS.PACKAGE_READY_TO_PICK_UP]: "Paquete Listo para Entrega",
    [PACKAGE_NOTIFICATIONS.PACKAGE_COST]: "Notificacion sobre tu paquete",
    [PACKAGE_NOTIFICATIONS.PACKAGE_ON_ROUTE]: "Tu paquete esta en Ruta",
}

export const CARGO_MOVE_NOTIFICATIONS_BY_STATUS = {
    [MOVEMENT_STATUS_CODES.ON_TRANSIT]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_DESTINY]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_CUSTOMS]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_SCHEDULE]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_TRANSIT_COURIER]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_RED]: PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE,
    [MOVEMENT_STATUS_CODES.ON_COURIER]: PACKAGE_NOTIFICATIONS.PACKAGE_READY_TO_PICK_UP,
}


export const SEQUENCETYPES = {
    "AIR_TRANSPORTATION": "AIR_TRANSPORTATION",
    "SEA_TRANSPORTATION": "SEA_TRANSPORTATION",
    "GROUND_TRANSPORTATION": "GROUND_TRANSPORTATION",
    "DELIVERY_TRANSPORTATION": "DELIVERY_TRANSPORTATION",
    "EXP_AIR": "EXP_AIR_TRANSPORTATION",
    "EXP_SEA": "EXP_SEA_TRANSPORTATION",
    "EXP_GROUND": "EXP_GROUND_TRANSPORTATION",
    "EXP_DELIVERY": "EXP_DELIVERY_TRANSPORTATION",
    "PO_BOX": "PO_BOX",
    "DELIVERY_ROUTE": "DELIVERY_ROUTE",
    "BOX": "BOX",
    "COST": "COST"
}

export const SEQUENCETYPES_PREFIX = {
    "AIR_TRANSPORTATION": "A",
    "SEA_TRANSPORTATION": "S",
    "GROUND_TRANSPORTATION": "T",
    "DELIVERY_TRANSPORTATION": "D",
    "EXP_AIR_TRANSPORTATION": "EXPA",
    "EXP_SEA_TRANSPORTATION": "EXPS",
    "EXP_GROUND_TRANSPORTATION": "EXPG",
    "EXP_DELIVERY_TRANSPORTATION": "EXPD",
    "PO_BOX": "",
    "DELIVERY_ROUTE": "",
    "BOX": "B",
    "COST": ""
}

export const countryList = {
    "US": "Estado Unidos",
    "CR": "Costa Rica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "BS": "Bahamas",
    "BB": "Barbados",
    "BZ": "Belize",
    "BM": "Bermuda",
    "BO": "Bolivia",
    "BR": "Brazil",
    "CL": "Chile",
    "CN": "China",
    "CO": "Colombia",
    "DO": "Republica Dominicana",
    "EC": "Ecuador",
    "SV": "El Salvador",
    "GT": "Guatemala",
    "HN": "Honduras",
    "MX": "Mexico",
    "NI": "Nicaragua",
    "PA": "Panama",
    "PY": "Paraguay",
    "PE": "Peru",
    "PR": "Puerto Rico",
    "TT": "Trinidad and Tobago",
    "UY": "Uruguay",
    "VE": "Venezuela",
};

export const ANALYTIC_EVENT_CATEGORIES = {
    "USER": "User",
    "NAVIGATION": "Navigation",
    "FORM": "Form"
}

export const ANALYTIC_EVENT_ACTIONS = {
    CLICK_LOGIN: "Click Login",
    CLICK_LOGIN_GOOGLE: "Click Google Login",
    CLICK_REGISTER: "Click Register",
    CLICK_BUTTON: "Clicked Button",
    SUBMIT_FORM: "Submit Form",
    OPEN_MODAL: "Open Modal"
}
